import { render, staticRenderFns } from "./FilesUploader.vue?vue&type=template&id=94290bf6&scoped=true&"
import script from "./FilesUploader.vue?vue&type=script&lang=ts&"
export * from "./FilesUploader.vue?vue&type=script&lang=ts&"
import style0 from "./FilesUploader.vue?vue&type=style&index=0&id=94290bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94290bf6",
  null
  
)

export default component.exports